import { render, staticRenderFns } from "./ExtLayout.vue?vue&type=template&id=15025728&"
import script from "./ExtLayout.vue?vue&type=script&lang=ts&"
export * from "./ExtLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports